import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import thunk from 'redux-thunk';
import * as reducers from './legacy/reducers';
import { intlSelector } from './legacy/selector/appSelectors';
import { refreshAuthToken } from './legacy/actions/userActions';
import * as Sentry from '@sentry/react';
import { userCookie } from '~/models/UserCookie';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => {
    switch (action.type) {
      case 'meal : by restaurants : fetch SUCCESS':
        return {
          ...action,
          meals: `[Array: ${action.meals.length} meals]`,
        };
      case 'delivery : delivery groups : fetch SUCCESS':
        return {
          ...action,
          deliveryGroups: `[Array: ${action.deliveryGroups.length} deliveryGroups]`,
        };
      default:
        return action;
    }
  },
  stateTransformer: (state) => {
    // Transform the state to remove sensitive information
    const transformedState = {
      ...state,
      userStore: {
        ...state.userStore,
        accessToken: '[redacted]',
      },
    };
    return transformedState;
  },
});

export function configureStore(preloadedState) {
  const middlewares = applyMiddleware(thunk.withExtraArgument({ intl: intlSelector }));
  const enhancers = composeEnhancers(middlewares, sentryReduxEnhancer);
  const store = createStore(
    combineReducers({
      ...reducers,
    }),
    preloadedState,
    enhancers
  );
  const next = store.dispatch;
  store.dispatch = function (action) {
    const isUserLoggedIn = userCookie.isLoggedIn;
    if (!isUserLoggedIn) {
      return next(action);
    }
    const expireTime = userCookie.expireTime;
    if (expireTime && expireTime > new Date().getTime()) {
      return next(action);
    }
    next(
      refreshAuthToken({
        callback: () => next(action),
      })
    );
  };
  return store;
}

function composeEnhancers(...args) {
  return typeof window !== 'undefined' ? composeWithDevTools({})(...args) : compose(...args);
}
